export default {
  0: { name: 'Instrument 1' },
  1: { name: 'Instrument 2' },
  2: { name: 'Instrument 3' },
  3: { name: 'Instrument 4' },
  4: { name: 'Instrument 5' },
  5: { name: 'Instrument 6' },
  6: { name: 'Instrument 7' },
  7: { name: 'Instrument 8' },
  16: { name: 'Sample' },
  17: { name: 'Command Mode' },
  18: { name: 'Key Range' },
  19: { name: 'Edit Mode' },
  20: { name: 'Load Mode' },
  21: { name: 'MIDI' },
  22: { name: 'Seq · Song' },
  23: { name: 'Instrument' },
  24: { name: 'System' },
  32: { name: 'Up Arrow' },
  33: { name: 'Down Arrow' },
  34: { name: 'Left Arrow' },
  35: { name: 'Cancel' },
  36: { name: 'Right Arrow' },
  37: { name: 'Enter · Yes' },
  48: { name: '0 · Track' },
  49: { name: '1 · Env 1' },
  50: { name: '2 · Env 2' },
  51: { name: '3 · Env 3' },
  52: { name: '4 · Pitch' },
  53: { name: '5 · Filter' },
  54: { name: '6 · Amp' },
  55: { name: '7 · LFO' },
  56: { name: '8 · Wave' },
  57: { name: '9 · Layer' },
};
